import { PerAccountLocalStorage, StorageKeys } from '../../services/PerAccountLocalStorage';

const STORAGE_KEY = 'noornote_bulk_delete_enabled';

export function isBulkDeleteEnabled(): boolean {
  const perAccount = PerAccountLocalStorage.getInstance().get<boolean | null>(
    StorageKeys.BULK_DELETE_ENABLED, null
  );
  if (perAccount !== null) return perAccount;
  return localStorage.getItem(STORAGE_KEY) === 'true';
}

export function setBulkDeleteEnabled(enabled: boolean): void {
  PerAccountLocalStorage.getInstance().set(StorageKeys.BULK_DELETE_ENABLED, enabled);
  localStorage.setItem(STORAGE_KEY, 'false');
}
